<!-- <div class="container_width w-full flex flex-column gap-5 mx-auto">
  <div class="flex flex-column md:flex-row w-full gap-5 md:gap-0">
    <div class="md:col-5 lg:col-4 col-12 p-0 md:pr-3 flex flex-column gap-4">
      <div class="flex flex-column gap-3">
        <b class="text-xl font-bold">My Colleges</b>
        <div class="flex flex-column gap-2">
          <p-button styleClass="essay_btn"
            class="flex align-items-center cursor-pointer justify-content-between font-normal text-base text-bluegray-700 hover:text-bluegray-900 active:text-bluegray-900 border-1 border-bluegray-300 border-round-lg bg-white hover:bg-bluegray-100 active:bg-bluegray-100">
            <span>University of Pennsylvania</span>
            <i class="pi pi-angle-right"></i>
          </p-button>
        </div>
        <div class="w-full mt-2">
          <a class="add_inf cursor-pointer  w-full flex align-items-center justify-content-between py-3 px-4 border-round-lg text-left font-normal text-base" style=" color: #111111;">Additional Information <i class="pi pi-angle-right"></i></a>
        </div>
      </div>
    </div>

    <div class="md:col-7 lg:col-8 col-12 p-0 md:pl-3">
      <p-tabView styleClass="tab_style">
        <p-tabPanel header="Pending Requests">
            <div class="w-full flex flex-column gap-3">
                <h2 class="w-full text-left font-medium text-xl" style="color: #111111;">Pending Requests</h2>

                <div class="w-full flex flex-column gap-2">
                    <div class="w-full flex gap-3 p-3 border-round-lg bg-white">
                        <div class="w-full flex gap-2">
                            <div class="w-3rem h-3rem border-circle overflow-hidden flex-shrink-0">
                                <img src="../../../assets/images/avatar1.jpg" alt="" style="width: 100%; height: 100%; object-fit: cover;">
                            </div>
                            <div class="w-full flex flex-column gap-2">
                                <div class="w-full p-2" style="background-color: #F3F3F3; border-radius: 0 8px 8px 8px;">
                                  <p class="text-left font-normal text-base" style="color: #111111;">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
                                </div>
                                <small class="w-full block text-left font-normal" style="color: #505050; font-size: 13px;">Date : 07-FEB-2025</small>
                            </div>
                        </div>
                        <div class="w-auto">
                          <p-button (onClick)="showDialog()" label="Reply" icon="pi pi-reply" styleClass="reply"/>
                        </div>
                    </div>
                    <div class="w-full flex gap-3 p-3 border-round-lg bg-white">
                      <div class="w-full flex gap-2">
                          <div class="border-circle overflow-hidden flex-shrink-0" style="width: 40px; height: 40px;">
                              <img src="../../../assets/images/avatar1.jpg" alt="" style="width: 100%; height: 100%; object-fit: cover;">
                          </div>
                          <div class="w-full flex flex-column gap-2">
                              <div class="w-full p-2" style="background-color: #F3F3F3; border-radius: 0 8px 8px 8px;">
                                <p class="text-left font-normal text-base" style="color: #111111;">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
                              </div>
                              <small class="w-full block text-left font-normal" style="color: #505050; font-size: 13px;">Date : 07-FEB-2025</small>
                          </div>
                      </div>
                      <div class="w-auto">
                        <p-button (onClick)="showDialog()" label="Reply" icon="pi pi-reply" styleClass="reply"/>
                      </div>
                  </div>
                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Resolved Requests">
          <div class="w-full flex flex-column gap-3">
            <h2 class="w-full text-left font-medium text-xl" style="color: #111111;">Resolved Requests</h2>

            <div class="w-full flex flex-column gap-2">
                <div class="w-full flex flex-column gap-3 p-3 border-round-lg bg-white">
                    <div class="w-full flex gap-2" style="padding-right: 132px;">
                        <div class="w-3rem h-3rem border-circle overflow-hidden flex-shrink-0">
                            <img src="../../../assets/images/avatar1.jpg" alt="" style="width: 100%; height: 100%; object-fit: cover;">
                        </div>
                        <div class="w-full flex flex-column gap-2">
                            <div class="w-full p-2" style="background-color: #F3F3F3; border-radius: 0 8px 8px 8px;">
                              <p class="text-left font-normal text-base" style="color: #111111;">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
                            </div>
                            <small class="w-full block text-left font-normal" style="color: #505050; font-size: 13px;">Date : 07-FEB-2025</small>
                        </div>
                    </div>
                    <div class="w-full flex gap-2" style="padding-left: 132px;">
                      <div class="w-full flex flex-column gap-2">
                          <div class="w-full flex flex-column gap-2 p-2" style="background-color: #FAFAD8; border-radius: 8px 0 8px 8px;">
                            <b class="w-full block text-right font-medium " style="font-size: 17px; color: #111111;">Jonathan Smith</b>
                            <p class="text-right font-normal text-base" style="color: #555;">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
                          </div>
                          <div class="w-full flex align-items-center justify-content-between">
                            <p-button label="Attachment" icon="pi pi-paperclip" styleClass="attach_ment"/>
                            <small class="w-auto inline-block text-left font-normal" style="color: #505050; font-size: 13px;">Date : 07-FEB-2025</small>
                          </div>
                      </div>
                      <div class="w-3rem h-3rem border-circle overflow-hidden flex-shrink-0">
                        <img src="../../../assets/images/avatar1.jpg" alt="" style="width: 100%; height: 100%; object-fit: cover;">
                    </div>
                  </div>
                </div>
                <div class="w-full flex flex-column gap-3 p-3 border-round-lg bg-white">
                  <div class="w-full flex gap-2" style="padding-right: 132px;">
                      <div class="w-3rem h-3rem border-circle overflow-hidden flex-shrink-0">
                          <img src="../../../assets/images/avatar1.jpg" alt="" style="width: 100%; height: 100%; object-fit: cover;">
                      </div>
                      <div class="w-full flex flex-column gap-2">
                          <div class="w-full p-2" style="background-color: #F3F3F3; border-radius: 0 8px 8px 8px;">
                            <p class="text-left font-normal text-base" style="color: #111111;">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
                          </div>
                          <small class="w-full block text-left font-normal" style="color: #505050; font-size: 13px;">Date : 07-FEB-2025</small>
                      </div>
                  </div>
                  <div class="w-full flex gap-2" style="padding-left: 132px;">
                    <div class="w-full flex flex-column gap-2">
                        <div class="w-full flex flex-column gap-2 p-2" style="background-color: #FAFAD8; border-radius: 8px 0 8px 8px;">
                          <b class="w-full block text-right font-medium " style="font-size: 17px; color: #111111;">Jonathan Smith</b>
                          <p class="text-right font-normal text-base" style="color: #555;">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
                        </div>
                        <div class="w-full flex align-items-center justify-content-between">
                          <p-button label="Attachment" icon="pi pi-paperclip" styleClass="attach_ment"/>
                          <small class="w-auto inline-block text-left font-normal" style="color: #505050; font-size: 13px;">Date : 07-FEB-2025</small>
                        </div>
                    </div>
                    <div class="w-3rem h-3rem border-circle overflow-hidden flex-shrink-0">
                      <img src="../../../assets/images/avatar1.jpg" alt="" style="width: 100%; height: 100%; object-fit: cover;">
                  </div>
                </div>
              </div>
            </div>
        </div>
        </p-tabPanel>
    </p-tabView>
    </div>
  </div>
</div> -->

<div class="w-full">
  <!-- Loading Spinner -->
  <ng-container *ngIf="isLoadingData; else additionalInfo">
    <div class="flex gap-4 align-items-center justify-content-center py-5">
      <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" fill="var(--surface-ground)"
        animationDuration=".5s">
      </p-progressSpinner>
    </div>
  </ng-container>

  <ng-template #additionalInfo>
    <p-tabView styleClass="tab_style">
      <!-- Pending Requests -->
      <p-tabPanel header="Pending Tasks">
        <div class="w-full flex flex-column gap-3">
          <h2 class="w-full text-left font-medium text-xl text-dark">Pending Tasks</h2>
          <div class="w-full flex flex-column gap-2">
            <div *ngFor="let item of pendingQuestions?.additionalInfo"
              class="w-full flex gap-3 p-3 border-round-lg bg-white">
              <div class="w-full flex gap-2">
                <div class="w-3rem h-3rem border-circle overflow-hidden flex-shrink-0">
                  <img [src]="item.mentorImage || '../../../assets/images/avatar1.jpg'" alt="Mentor"
                    class="w-full h-full object-cover">
                </div>
                <div class="w-full flex flex-column gap-2">
                  <div class="w-full p-2 border-round-md" [style.background-color]="item.colourCode || '#e9ecef'">
                    <p class="text-left font-normal text-base text-dark" [style.color]="item.colourCode === '#12263F' || item.colourCode === '#000086' ? '#fff' : 'inherit'">{{ item.question }}</p>
                  </div>
                  <p-button *ngIf="item.requestedAttachment" label="Attachment" icon="pi pi-paperclip" styleClass="attach_ment"
                          (onClick)="openAttachment(item.requestedAttachment)" />
                  <small class="w-full block text-left text-secondary text-sm">{{item.createdOn | date: 'MMM dd, yyyy' }}</small>
                </div>
              </div>
              <div class="w-auto">
                <p-button (onClick)="showDialog(item.id)" label="Reply" icon="pi pi-reply" styleClass="reply" />
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>

      <!-- Resolved Requests -->
      <p-tabPanel header="Resolved Tasks">
        <div class="w-full flex flex-column gap-3">
          <h2 class="w-full text-left font-medium text-xl text-dark">Resolved Tasks</h2>
          <div class="w-full flex flex-column gap-2">
            <div *ngFor="let item of resolvedQuestions?.additionalInfo"
              class="w-full flex flex-column gap-3 p-3 border-round-lg bg-white">
              <div class="w-full flex gap-2 pr-8">
                <div class="w-3rem h-3rem border-circle overflow-hidden flex-shrink-0">
                  <img [src]="item.mentorImage || '../../../assets/images/avatar1.jpg'" alt="Mentor"
                    class="w-full h-full object-cover">
                </div>
                <div class="w-full flex flex-column gap-2">
                  <div class="w-full p-2 border-round-md" [style.background-color]="item.colourCode || '#e9ecef'">
                    <b class="w-full block text-left font-medium mb-1"
                      [style.color]="item.colourCode === '#12263F' || item.colourCode === '#000086' ? '#fff' : '#111111'"
                      style="font-size: 17px;">{{item.mentorName}}</b>
                    <p class="text-left font-normal text-base text-dark" [style.color]="item.colourCode === '#12263F' || item.colourCode === '#000086' ? '#fff' : 'inherit'">{{ item.question }}</p>
                  </div>
                  <p-button *ngIf="item.requestedAttachment" label="Attachment" icon="pi pi-paperclip" styleClass="attach_ment"
                          (onClick)="openAttachment(item.requestedAttachment)" />
                  <small class="w-full block text-left text-secondary text-sm">{{item.createdOn | date: 'MMM dd, yyyy' }}</small>
                </div>
              </div>
              <div class="w-full flex gap-2 pl-8">
                <div class="w-full flex flex-column gap-2">
                  <div class="w-full flex flex-column gap-2 p-2 bg-yellow-100 border-round-md">
                    <b class="w-full block text-right font-medium text-lg text-dark mb-1">
                      {{ resolvedQuestions?.studentDetails?.studentName || 'Student' }}
                    </b>
                    <p class="text-right font-normal text-base text-gray-700">{{ item.reply }}</p>
                  </div>
                  <div class="w-full flex align-items-center justify-content-between">
                    <p-button *ngIf="item.attachementSAS" label="Attachment" icon="pi pi-paperclip"
                      styleClass="attach_ment" (onClick)="openAttachment(item.attachementSAS)" />
                    <small class="w-auto inline-block text-left text-secondary text-sm">{{item.updatedOn | date: 'MMM dd, yyyy' }}</small>
                  </div>
                </div>
                <div class="w-3rem h-3rem border-circle overflow-hidden flex-shrink-0">
                  <img [src]="resolvedQuestions?.studentDetails?.imageUrl || '../../../assets/images/avatar1.jpg'"
                    alt="Student" class="w-full h-full object-cover">
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </ng-template>
</div>

<p-dialog header="Task" [modal]="true" [(visible)]="visible" [style]="{ width: '30rem' }">
  <form [formGroup]="additionalInformationForm" (ngSubmit)="onReplySubmit()">
    <div class="flex flex-column align-items-center gap-3">
      <textarea class="w-full" formControlName="additionalInfo" rows="5" cols="30" pInputTextarea></textarea>
      <small class="text-red-500 block" *ngIf="additionalInformationForm.get('additionalInfo')?.invalid &&
                     (submitted || additionalInformationForm.get('additionalInfo')?.touched)">
          Information is required
      </small>
      <div class="w-full flex align-items-center gap-2">
        <p-fileUpload styleClass="fileupload" #fileUploader mode="basic" name="demo[]" accept=".pdf,.doc,.docx,image/*"
          fileLimit="1" (onSelect)="onFileSelect($event)" chooseIcon="pi pi-upload"
          url="https://www.primefaces.org/cdn/api/upload.php" maxFileSize="1000000" [auto]="false"
          chooseLabel="Browse"></p-fileUpload>
          <p-button  class="font-regular"
            (onClick)="onFileRemoved()"
            icon="pi pi-times"
            styleClass="closeIcon"
            [rounded]="true"
            appendTo="body"
            pTooltip="Clear image"
            tooltipPosition="top"
          />
      </div>
      <p-button label="Submit" [loading]="isLoading" styleClass="save_btn" type="submit"></p-button>
    </div>
  </form>
</p-dialog>
